import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { LAST_TRUCK_TRAILER_PAIRS } from 'api/query-keys.ts';
import type { TGetLastTruckTrailerPairsRes } from 'api/swagger';

interface IParams {
  truckIds?: number[];
  isSkip?: boolean;
}

export const useGetLastTruckTrailerPairs = (params: IParams) => {
  const qs = new URLSearchParams();

  params.truckIds?.forEach((value, index) => {
    qs.set(`filter[truckIds][${index}]`, String(value));
  });

  const queryString = qs.toString();

  return useQuery<TGetLastTruckTrailerPairsRes[]>({
    queryKey: [LAST_TRUCK_TRAILER_PAIRS, queryString],
    queryFn: async (): Promise<TGetLastTruckTrailerPairsRes[]> => {
      try {
        const { data } = await http.get<TGetLastTruckTrailerPairsRes[]>(
          `/v1/trips/truck-trailer-pairs/last?${queryString}`,
        );
        return data;
      } catch (error) {
        return returnIfNotFoundError<[]>(error, []);
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 0,
    cacheTime: 0,
    enabled: !params.isSkip,
  });
};
